import Crud from '../views/StatusProject/Crud'
import Entity from '../views/StatusProject/Add'

let routes = {
    path: '/status_projects',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/status_projects/add',
            name: 'NewUser',
            component: Entity
        },
        {
            path: '/status_projects/edit/:id?',
            name: 'EditStatusProject',
            component: Entity
        },
        {
            path: '/status_projects',
            name: 'list-status-projects',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Status dos Projetos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
